import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { BLOGS, IMAGES } from '../mock';
import { PageHero, SectionTitle, Reveal } from '../components/Shared';

export default function Blogs() {
  const [filter, setFilter] = useState('All');
  const cats = ['All', ...Array.from(new Set(BLOGS.map((b) => b.category)))];
  const list = filter === 'All' ? BLOGS : BLOGS.filter((b) => b.category === filter);

  return (
    <div>
      <PageHero eyebrow="Blog & Insights" title="Rheumatology insights & health tips" subtitle="Expert articles on arthritis, autoimmune disease, treatment and healthy living." image={IMAGES.physio} />

      <section className="py-20">
        <div className="container-x">
          <div className="flex flex-wrap gap-2 mb-10">
            {cats.map((c) => (
              <button key={c} onClick={() => setFilter(c)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${filter === c ? 'btn-teal' : 'bg-teal-50 text-teal-700 hover:bg-teal-100'}`}>{c}</button>
            ))}
          </div>

          <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-7">
            {list.map((b, i) => (
              <Reveal key={b.id} delay={(i % 3) * 80}>
                <Link to={`/blogs/${b.id}`} className="group card-lift bg-white rounded-2xl overflow-hidden border border-teal-50 h-full flex flex-col">
                  <div className="h-48 overflow-hidden">
                    <img src={IMAGES[b.image]} alt={b.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <span className="inline-block bg-teal-50 text-teal-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 w-fit">{b.category}</span>
                    <h3 className="text-lg text-teal-900 leading-snug mb-2 group-hover:text-teal-700 transition-colors" style={{ fontWeight: 600 }}>{b.title}</h3>
                    <p className="text-slate-600 text-sm leading-relaxed line-clamp-3">{b.excerpt}</p>
                    <div className="flex items-center gap-4 text-xs text-slate-400 mt-4">
                      <span className="flex items-center gap-1"><Calendar size={13} /> {b.date}</span>
                      <span className="flex items-center gap-1"><Clock size={13} /> {b.read}</span>
                    </div>
                    <span className="inline-flex items-center gap-1 text-teal-700 text-sm font-medium mt-4">Read article <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
